import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Table,
} from 'reactstrap';
import Panel from '../../../../../shared/components/Panel';
import { Theme } from '../../../../../shared/prop-types/MainProps';
import {
  getTableHeaderStyle,
  getTableWrapperStyle,
  isDarkTheme,
} from '../../../../../shared/helpers/themeTableStyles';

function AccountAccessPanel({
  initialLoad, getData, mapLine, apiData, theme,
}) {
  const isDarkMode = isDarkTheme(theme);

  return (
    <Panel lg={12} title="Account Access" getData={getData} parentRefresh={initialLoad}>
      <div style={getTableWrapperStyle(isDarkMode)}>
        <Table responsive className="table--bordered">
          <thead style={{ backgroundColor: isDarkMode ? '#232531' : '#f8f9fa' }}>
            <tr>
              <th style={getTableHeaderStyle(isDarkMode)}>First Name</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Last Name</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Email</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Active</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Logins Last 7 Days</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Access At</th>
            </tr>
          </thead>
          <tbody>
            {apiData && apiData.map((line, index) => mapLine(line, isDarkMode, index))}
          </tbody>
        </Table>
      </div>
    </Panel>
  );
}

AccountAccessPanel.propTypes = {
  initialLoad: PropTypes.bool.isRequired,
  getData: PropTypes.func.isRequired,
  mapLine: PropTypes.func.isRequired,
  apiData: PropTypes.instanceOf(Array).isRequired,
  theme: Theme.isRequired,
};

const mapStateToProps = (state) => {
  const { theme } = state;
  return { theme };
};

export default connect(mapStateToProps)(AccountAccessPanel);
